<template>
  <v-container align-center justify-center fill-height>
    <v-row class="mt-0">
      <v-col cols="12" md="12">
        Halaman About
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'About',
  data: () => ({
    title: 'About',
  }),
  mounted() {
    this.$store.commit('UPDATE_TITLE', 'About');
  },
  created: () => ({
  }),
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
